export default __webpack_public_path__ + "static/media/CarImages.SportagGallery6.9b12ea61.jpg";